<section>
  <div class="container">
    <div class="left-section">
      <h2 translate mat-dialog-title>Create Events</h2>
      <mat-dialog-content>
        <form [formGroup]="pagecreationForm" class="event-form">
          <div class="form-group">
            <div *ngFor="let question of questions">
              <app-question
                [question]="question"
                [form]="pagecreationForm"
              ></app-question>
            </div>
          </div>
        </form>
      </mat-dialog-content>
    </div>

    <div class="right-section">
      <div class="upload-container">
        <label translate for="image-upload" class="upload-label">Upload Images</label>
        <div
          class="upload-dashed-border"
          (click)="fileInput.click()"
          *ngIf="!images.length && !previewUrls.length"
        >
          <span translate>Click to upload</span>
        </div>
        <input
          id="image-upload"
          type="file"
          (change)="onImageUpload($event)"
          multiple
          class="upload-input"
          #fileInput
          style="display: none"
        />

        <div
          *ngIf="images.length || previewUrls.length"
          class="carousel-container"
        >
          <button
            class="carousel-nav prev"
            (click)="prevSlide()"
            aria-label="Previous Slide"
          >
            &#10094;
          </button>
          <div
            class="carousel-slide"
            *ngFor="let item of previewUrls; let i = index"
            [class.active]="i === currentSlide"
          >
            <img
              [src]="item.image_url"
              alt="Uploaded image"
              class="carousel-image"
            />
            <button class="delete-image" (click)="deleteImage(i)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <button
            class="carousel-nav next"
            (click)="nextSlide()"
            aria-label="Next Slide"
          >
            &#10095;
          </button>
        </div>
        <h5>Number Of Images: {{ previewUrls.length }}</h5>
        <div *ngIf="previewUrls.length > 0">
          <button
            mat-raised-button
            color="primary"
            class="add-more-button"
            (click)="fileInput.click()"
          >
            <i class="fa-solid fa-plus"></i>Add More
          </button>
        </div>
      </div>
    </div>
  </div>

  <mat-dialog-actions class="dialog-actions bottom-actions">
    <button translate mat-stroked-button (click)="onCancel()" class="cancel_button">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSubmit()">
      {{ editflag ? ("Update" | translatepipe) : ("Submit" | translatepipe) }}
    </button>
  </mat-dialog-actions>
</section>
